"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function NextSteps() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: paragraphRef,
    isVisible: paragraphVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: buttonsRef,
    isVisible: buttonsVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: linkRef,
    isVisible: linkVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section className="bg-light-background py-16 px-6 md:py-24">
      <div className="mx-auto max-w-3xl flex flex-col items-center text-center space-y-6">
        <h2 ref={headlineRef} className={`font-display text-3xl md:text-4xl lg:text-5xl font-bold text-foreground transition-all duration-[var(--duration-slow)] ${headlineVisible ? "opacity-100 translate-y-0 animate-pulse" : "opacity-0 translate-y-4"}`}>
          Ready to Take the Next Step?
        </h2>

        <p ref={paragraphRef} className={`font-sans text-base md:text-lg text-muted-foreground max-w-2xl transition-all duration-[var(--duration-medium)] delay-100 ${paragraphVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>Join the many learners who have transformed their education journey with our comprehensive courses and expert guidance. Start your path to success today.</p>

        <div ref={buttonsRef} className={`flex flex-col sm:flex-row gap-4 transition-all duration-[var(--duration-medium)] delay-200 ${buttonsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <Link to="/SubjectsPage">
            <Button variant="default" size="lg" className="font-semibold text-white shadow-soft hover:shadow-medium hover:-translate-y-0.5 active:translate-y-0 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
              Explore Subjects
            </Button>
          </Link>

          <Link to="/ContactPage">
            <Button variant="outline" size="lg" className="font-semibold shadow-soft hover:shadow-medium hover:-translate-y-0.5 active:translate-y-0 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
              Get in Touch
            </Button>
          </Link>
        </div>

        <div ref={linkRef} className={`transition-all duration-[var(--duration-medium)] delay-300 ${linkVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          
        </div>
      </div>
    </section>;
}